<script setup lang="ts">
import CtaArrowRightIcon from '@/assets/icons/cta-arrow-right.svg?component'
defineProps<{
  title: string
  hideArrow?: boolean
}>()

const emit = defineEmits<{
  (e: 'click'): void
}>()
</script>

<template>
  <div class="MessageCta" @click="emit('click')">
    <div v-if="$slots.image" class="MessageCta__Image">
      <slot name="image"></slot>
    </div>
    <div class="MessageCta__Copy">
      <p class="MessageCta__Title">{{ title }}</p>
      <p class="MessageCta__Body"><slot name="body"></slot></p>
    </div>
    <div v-if="!hideArrow" class="MessageCta__Actions">
      <CtaArrowRightIcon width="20" />
    </div>
  </div>
</template>

<style>
.MessageCta {
  background: var(--Ocean-100, #007f8f);
  padding: 20px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 16px;
  cursor: pointer;
  color: var(--color-white);
}

.MessageCta__Copy {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}

.MessageCta__Title {
  font-weight: bold;
  margin: 0;
}

.MessageCta__Body {
  font-size: 14px;
  margin: 6px 0 0;
  line-height: 1.5;
}

.MessageCta__Actions {
  display: flex;

  svg {
    color: var(--color-white);
  }
}
</style>
